import { Image } from "antd";
import { comma,BACKEND_URL_MAIN } from '../../../utils/util';


export const productColumn = () => [
  {
    title: "ลำดับ",
    dataIndex: "ind",
    key: "ind",
    align: "center",
    width: 60,
    render: (im, rc, index) => <>{index + 1}</>,
  },
  {
    title: "รูปประกอบ",
    dataIndex: "file",
    key: "file",
    width: 120,
    align: "center",
    render: (im, rec) => {
      const img = (!!rec.file_name ? `/uploads/` + rec.file_name : `/Logo-AI.png`
      );
      return <>
        <Image
          style={{ borderRadius: 10 }}
          preview={false}
          height={75}
          alt={`Image ${rec.file_name}`}
          src={`${BACKEND_URL_MAIN}` + img}
        />
      </>
    },
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "stcode",
    key: "stcode",
    width: 140,
    align: "center",
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "purdetail",
    key: "purdetail",
    align: "left",
    render: (_, rec) => rec.stname,
  },
  {
    title: "จำนวนที่ควรซื้อ",
    dataIndex: "qty",
    key: "qty",
    width: "15%",
    align: "center",
    className: "!pe-3",
    editable: true,
    required: true,
    type: 'number',
    render: (_, rec) => <>{Number(rec?.qty || 0)}</>,
  },
  {
    title: "ราคาซื้อ",
    dataIndex: "price",
    key: "price", 
    width: "8%",
    align: "right",
    className: "!pe-3",
    editable: true,
    required: true,
    type:'number',
    render: (_, rec) => <>{ comma( Number(rec?.price ||  0),  2, 2 )}</>,
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    align: "center",
    render: (_, rec) => rec.unit,
  },
];

export const columnsParametersEditable = (handleEditCell, optionsItems, { handleRemove }) => {
  const col = productColumn({ handleRemove }, optionsItems);
  return col.map((col, ind) => {
    if (!col.editable) return col;

    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          // required: !!col?.required,
          type: col?.type || "input",
          handleEditCell,
          optionsItems,
        }
      },
    };
  });
}